"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var AppSpinner_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/app-spinner/AppSpinner"));
var earn_activity_header_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/earn/earn-activity-header"));
var package_1 = require("@pbl/pbl-react-web-components/lib/package");
var SurveyContent_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/survey/pbl/SurveyContent"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var constants_1 = __importStar(require("../../config/constants"));
var actions_1 = require("../../redux/reducers/app/actions");
var actions_2 = require("../../redux/reducers/ledger/actions");
var actions_3 = require("../../redux/reducers/survey/actions");
var useActivityDetailsData_1 = require("../../shared/hooks/providers/useActivityDetailsData");
var useSurveyDetails_1 = require("../../shared/hooks/providers/useSurveyDetails");
var useScrollToTop_1 = require("../../shared/hooks/useScrollToTop");
var framework_1 = require("../../widgets/framework");
var styles_2 = __importDefault(require("./styles"));
var SurveyScreen = function (_a) {
    var classes = _a.classes, t = _a.t, identifier = _a.identifier, titleComponent = _a.titleComponent;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigateToActivities = (0, react_1.useCallback)(function (message) {
        var appNavigate = {
            action: 'ACTIVITIES',
            data: message
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    }, []);
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }), loggedIn = _b.isAuthenticated, isRestricted = _b.isRestricted;
    var showInvalidError = (0, react_1.useCallback)(function () {
        navigateToActivities({
            message: t('activities.activityUnavailable'),
            type: 'warning',
            messageTimeout: 3000
        });
    }, [navigateToActivities, t]);
    var activityId = identifier + '';
    var activity = (0, useActivityDetailsData_1.useActivityDetailsData)(activityId, loggedIn, showInvalidError).activity;
    var _c = (0, useSurveyDetails_1.useSurveyDetails)(showInvalidError, loggedIn, activity === null || activity === void 0 ? void 0 : activity.key), survey = _c.survey, playerResponses = _c.playerResponses;
    var _d = (0, react_1.useState)(false), loading = _d[0], setLoading = _d[1];
    var _e = (0, react_1.useState)(''), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = (0, react_1.useState)(false), isFormDirty = _f[0], setIsFormDirty = _f[1];
    var _g = (0, react_1.useState)({}), surveyResult = _g[0], setSurveyResult = _g[1];
    var _h = (0, react_1.useState)(false), showModal = _h[0], setShowModal = _h[1];
    var _j = (0, react_1.useState)({}), userResponse = _j[0], setUserResponse = _j[1];
    (0, react_1.useEffect)(function () {
        var _a;
        setUserResponse({ surveyId: (_a = survey === null || survey === void 0 ? void 0 : survey.id) !== null && _a !== void 0 ? _a : 0, responses: playerResponses !== null && playerResponses !== void 0 ? playerResponses : [] });
    }, [survey, playerResponses]);
    (0, useScrollToTop_1.useScrollToTop)();
    var redirectToLogin = function () {
        framework_1.GoFwInternalInstance.onHostLogin();
    };
    var redirectContactUs = function () {
        var appNavigate = {
            action: 'CONTACT_US'
        };
        framework_1.GoFwInternalInstance.onHostNavigate(appNavigate);
    };
    var postSurvey = function () { return __awaiter(void 0, void 0, void 0, function () {
        var responses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!loggedIn) {
                        redirectToLogin();
                        return [2];
                    }
                    setLoading(true);
                    responses = userResponse.responses;
                    responses.forEach(function (item) { return (item.responseText ? (item.options = undefined) : item); });
                    return [4, (0, actions_3.submit)(userResponse).then(function (data) { return validateResponse(data); })];
                case 1:
                    _a.sent();
                    dispatch((0, actions_2.fetchUserPoints)());
                    setLoading(false);
                    return [2];
            }
        });
    }); };
    var validateResponse = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            if (data && 'errorKey' in data && data.errorKey) {
                dispatch((0, actions_1.showMessageBar)({
                    message: t(data.errorKey),
                    type: 'error',
                    messageTimeout: 10000
                }));
                setErrorMessage(data.errorKey);
            }
            else if ((_a = data === null || data === void 0 ? void 0 : data.detail) === null || _a === void 0 ? void 0 : _a.includes('invalidAccess')) {
                dispatch((0, actions_1.showMessageBar)({
                    message: t('error.activity.invalidAccess'),
                    type: 'error',
                    messageTimeout: 10000
                }));
            }
            else if (data && activity) {
                setSurveyResult(data);
                setIsFormDirty(false);
                if (constants_1.default.INTERESTS_SURVEY.ACTIVITY_KEY === activity.key &&
                    'points' in data &&
                    data.points === 0 &&
                    !constants_1.default.HIDE_MESSAGE_BAR) {
                    dispatch((0, actions_1.showMessageBar)({ message: 'interests.updated' }));
                }
                else if ('points' in data && data.points === 0 && !constants_1.default.HIDE_MESSAGE_BAR) {
                    dispatch((0, actions_1.showMessageBar)({ message: 'survey.submitted' }));
                }
                else {
                    setShowModal(true);
                }
            }
            return [2];
        });
    }); };
    if (!activity || !survey) {
        return null;
    }
    var onChange = function (answer) {
        var _a;
        var currentResponses = (_a = userResponse.responses) !== null && _a !== void 0 ? _a : [];
        currentResponses = currentResponses.filter(function (x) { return x.questionId !== answer.questionId; });
        currentResponses.push(answer);
        setUserResponse({ surveyId: survey.id, responses: currentResponses });
        setIsFormDirty(true);
    };
    var onDismissEarnPointsModal = function () {
        navigateToActivities();
    };
    var getContent = function () {
        var bonusPoints = activity.bonusAmount ? activity.bonusAmount + activity.amount : 0;
        return survey ? (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 }, survey ? (react_1.default.createElement(SurveyContent_1.default, { onSaveSurvey: postSurvey, onChange: onChange, survey: survey, playerResponses: userResponse.responses, isLoading: loading, isSystemSurvey: constants_1.default.INTERESTS_SURVEY.ACTIVITY_KEY === (activity === null || activity === void 0 ? void 0 : activity.key), bonusPoints: bonusPoints, amount: activity.amount, limitReached: Boolean(constants_1.default.INTERESTS_SURVEY.ACTIVITY_KEY !== (activity === null || activity === void 0 ? void 0 : activity.key) &&
                playerResponses &&
                playerResponses.length > 0 &&
                !survey.updateResponses), isRestricted: loggedIn && isRestricted, handleContactUs: redirectContactUs, isLoggedIn: loggedIn, showSignInWarning: !loggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING') })) : null)) : null;
    };
    return (react_1.default.createElement("div", null,
        surveyResult && surveyResult.points ? (react_1.default.createElement(package_1.EarnPointsModal, { pointEarned: surveyResult.points, isVisible: showModal, onClose: onDismissEarnPointsModal })) : null,
        survey && (react_1.default.createElement("div", { className: classes.container }, loading ? (react_1.default.createElement(AppSpinner_1.default, { label: 'Loading Data' })) : (react_1.default.createElement(Grid_1.default, { className: classes.container, container: true, spacing: 2 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(earn_activity_header_1.default, { data: {
                        image: activity.imageUrl,
                        title: activity.title,
                        description: activity.description,
                        points: activity.amount,
                        preview_url: activity.videoUrl ? activity.videoUrl : undefined,
                        isCoverImage: true
                    }, bonusPoints: activity.bonusAmount ? activity.bonusAmount + activity.amount : 0, limitReached: playerResponses && playerResponses.length > 0, navigateTo: navigateToActivities, hideBackBtn: true, showSignInWarning: !loggedIn && constants_1.RemoteConstants.getBoolean('SHOW_SIGN_IN_WARNING'), redirectToLogin: postSurvey, titleComponent: titleComponent }),
                getContent())))))));
};
exports.default = (0, react_i18next_1.withTranslation)()((0, styles_1.withStyles)(styles_2.default)(SurveyScreen));
//# sourceMappingURL=index.js.map